import { useEffect, useState } from 'react';

// The part of the screen the user can actually see. When the on-screen
// keyboard opens, most phones shrink only this "visual" viewport and scroll the
// page under it, so a full-screen overlay sized to the layout viewport ends up
// with its top above the screen. Returns a style that pins an overlay to the
// visible area instead (empty where the browser can't tell us).
export default function useVisibleViewport() {
  const [style, setStyle] = useState({});
  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!vv) return undefined;
    const update = () => setStyle({ top: `${vv.offsetTop}px`, height: `${vv.height}px`, bottom: 'auto' });
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);
  return style;
}
